import historyStorage from './history-storage';

export function setupFilterableListing( container ) {
	const innerContainer = container.querySelector( '.js-filterable-inner' );
	const search = container.querySelector( '.js-filterable-search' );
	const filters = [ ...container.querySelectorAll( '.js-filter-input' ) ];
	const sets = [ ...container.querySelectorAll( '.js-filterable-set' ) ];
	const items = [ ...container.querySelectorAll( '.js-filterable' ) ];
	const filterPrompt = container.querySelector( '.js-filterable-filter-prompt' );
	const noResults = container.querySelector( '.js-filterable-no-results' );

	const foundTags = new Map();
	const itemTags = new WeakMap();
	const itemKeywords = new WeakMap();

	const currentFilters = historyStorage.getItem( container.id ) || {};

	if ( noResults ) {
		noResults.hidden = true;
	}

	items.forEach( item => {
		const tags = JSON.parse( item.dataset.tags || '{}' );
		const keywords = JSON.parse( item.dataset.keywords || '[]' );

		for ( const key in tags ) {
			const found = foundTags.get( key ) || new Set();
			for ( const tag of tags[ key ] ) {
				found.add( tag );
			}
			foundTags.set( key, found );
		}
		itemTags.set( item, tags );
		itemKeywords.set( item, keywords );
	} );

	function filterItems() {
		const selected = filters.filter( input => input.value !== '' )
			.map( filter => ( { key: filter.name, value: filter.value } ) );

		if ( filterPrompt ) {
			const prompt = filterPrompt.dataset.prompt;
			const filter = selected.find( f => f.key === prompt );
			if ( filter ) {
				filterPrompt.classList.add( 'hidden' );
				innerContainer.classList.remove( 'hidden' );
			} else {
				filterPrompt.classList.remove( 'hidden' );
				innerContainer.classList.add( 'hidden' );
			}
		}

		const query = ( search?.value || '' ).trim().normalize( 'NFD' ).replace( /[\u0300-\u036f]/g, '' ).toLowerCase().split( /\s+/ ).filter( v => v !== '' );

		historyStorage.setItem( container.id, {
			...selected,
			search: search?.value || '',
		} );

		items.forEach( item => {
			item.setAttribute( 'aria-hidden', item.hidden = false );
			const allKeywords = itemKeywords.get( item );

			if ( query.length > 0 ) {
				let keywordMatch = 0;

				for ( const term of query ) {
					for ( const keyword of allKeywords ) {
						if ( keyword.startsWith( term ) ) {
							keywordMatch++;
						}
					}
				}

				if ( keywordMatch < query.length ) {
					item.setAttribute( 'aria-hidden', item.hidden = true );
					return;
				}
			}

			const allTags = itemTags.get( item );
			for ( const filter of selected ) {
				if ( filter.value === '' ) {
					continue;
				}

				const tags = allTags[ filter.key ] || [];
				if ( ! tags.includes( filter.value ) ) {
					item.setAttribute( 'aria-hidden', item.hidden = true );
					return;
				}
			}
		} );

		sets.forEach( set => {
			const _items = [ ...set.querySelectorAll( '.js-filterable' ) ];
			const hidden = _items.filter( item => item.hidden );

			set.setAttribute( 'aria-hidden', set.hidden = _items.length === hidden.length );
		} );

		noResults.hidden = items.find( item => ! item.hidden );
	}

	if ( search ) {
		search.value = currentFilters.search || '';
		search.addEventListener( 'input', () => filterItems() );
	}

	filters.forEach( filter => {
		const options = filter.querySelectorAll( 'option:not([value=""])' );
		const noneOption = [ ...options ].find( option => [ '0', 'none' ].includes( option.value ) );
		const found = foundTags.get( filter.name );

		if ( found ) {
			let availableOptions = options.length;
			options.forEach( option => {
				if ( option.value && ! found.has( option.value ) ) {
					filter.removeChild( option );
					availableOptions--;
				}
			} );

			// Hide if either no options to choose from, or only 1 option and it's not the none option
			if ( availableOptions === 0 || ( noneOption && ! noneOption.parentElement && availableOptions === 1 ) ) {
				filter.setAttribute( 'aria-hidden', filter.hidden = true );
				filter.value = '';
				const wrapper = filter.closest( '.js-filter' );
				wrapper.setAttribute( 'aria-hidden', wrapper.hidden = true );
				return;
			}
		}

		if ( currentFilters[ filter.name ] ) {
			filter.value = currentFilters[ filter.name ];
			filter.dispatchEvent( new Event( 'change' ) );
		}

		filter.addEventListener( 'change', filterItems );
	} );

	container.addEventListener( 'click', event => {
		const target = event.target.closest( 'a' ) || event.target;

		if ( target.dataset.filter ) {
			event.preventDefault();

			const [ name, value = null ] = target.dataset.filter.split( ':' );
			const filter = container.querySelector( `[name="${ name }"]` );
			if ( filter ) {
				filter.value = value;
				filter.dispatchEvent( new Event( 'change' ) );
			}

			filterItems();
		}
	} );

	filterItems();
}

export default function setupFilterableListings() {
	document.querySelectorAll( '.js-filterable-listing' ).forEach( setupFilterableListing );
}
